import { Button, Typography } from "@mui/joy";
import { Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  formOpenSelector,
  selectedTalentID,
  setFormOpen,
  setSelectedTalentID,
} from "../../redux/filmsReducer";
import TalentRoute from "../../routes/talentPage";
import { FormBenefit } from "../benefit/benfitForm";
import { FormJobCategory } from "../jobCategory/jobCategoryForm";
import { FormProject } from "../project/projectFrom";
import { FormProjectType } from "../projectType/projectTypeForm";
import { FormScale } from "../scale/scaleForm";
import SlidingDialog from "../slidingDialog/slidingDialog";
import { FormTalent } from "../talent/talentForm";
import { FormTaskType } from "../taskType/taskTypeForm";
import { FormVendor } from "../vendors/vendorForm";

/**
 *
 * @returns {ReactElement} CreateCenter page
 */
export function CreateCenter() {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const dispatch = useDispatch();
  const projectFormOpen = useSelector(formOpenSelector("project"));
  const talentFormOpen = useSelector(formOpenSelector("talent"));
  const vendorFormOpen = useSelector(formOpenSelector("vendor"));
  const taskTypeFormOpen = useSelector(formOpenSelector("taskType"));
  const projectTypeFormOpen = useSelector(formOpenSelector("projectType"));
  const jobCategoryFormOpen = useSelector(formOpenSelector("jobCategory"));
  const scaleFormOpen = useSelector(formOpenSelector("scale"));
  const benefitFormOpen = useSelector(formOpenSelector("benefit"));
  const talentID = useSelector(selectedTalentID);
  return (
    <>
      <Button
        data-tut="reactour__create"
        variant="solid"
        color="primary"
        size="sm"
        endDecorator={<i className="far fa-plus-circle"></i>}
        onClick={(e: any) => {
          setAnchorEl(e.currentTarget);
        }}
      >
        Create
      </Button>
      <Menu
        sx={{ minWidth: 150 }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            dispatch(setFormOpen({ isOpen: true, formID: "project" }));
          }}
        >
          <Typography
            level="body-sm"
            startDecorator={<i className="fa-solid fa-folder-open" />}
          >
            Project
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            dispatch(setFormOpen({ isOpen: true, formID: "talent" }));
          }}
        >
          <Typography
            level="body-sm"
            startDecorator={<i className="fa-solid fa-user-music" />}
          >
            Talent
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            dispatch(setFormOpen({ isOpen: true, formID: "benefit" }));
          }}
        >
          <Typography
            level="body-sm"
            startDecorator={<i className="fa fa-hand-holding-dollar" />}
          >
            Benefit
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            dispatch(setFormOpen({ isOpen: true, formID: "vendor" }));
          }}
        >
          <Typography
            level="body-sm"
            startDecorator={<i className="fa-solid fa-building" />}
          >
            Vendor
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            dispatch(setFormOpen({ isOpen: true, formID: "projectType" }));
          }}
        >
          <Typography
            level="body-sm"
            startDecorator={<i className="fa-solid fa-tag" />}
          >
            Project Type
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            dispatch(setFormOpen({ isOpen: true, formID: "jobCategory" }));
          }}
        >
          <Typography
            level="body-sm"
            startDecorator={<i className="fa-solid fa-briefcase" />}
          >
            Job Category
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            dispatch(setFormOpen({ isOpen: true, formID: "taskType" }));
          }}
        >
          <Typography
            level="body-sm"
            startDecorator={<i className="fa-solid fa-hammer" />}
          >
            Task Type
          </Typography>
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            setAnchorEl(null);
            dispatch(setFormOpen({ isOpen: true, formID: "scale" }));
          }}
        >
          <Typography
            level="body-sm"
            startDecorator={<i className="fa-solid fa-money-bill" />}
          >
            Scale
          </Typography>
        </MenuItem> */}
      </Menu>

      {projectFormOpen ? <FormProject /> : []}
      {talentFormOpen ? <FormTalent /> : []}
      {vendorFormOpen ? <FormVendor /> : []}
      {jobCategoryFormOpen ? <FormJobCategory /> : []}
      {taskTypeFormOpen ? <FormTaskType /> : []}
      {projectTypeFormOpen ? <FormProjectType /> : []}
      {benefitFormOpen ? <FormBenefit /> : []}
      {scaleFormOpen ? <FormScale /> : []}

      <SlidingDialog
        open={Boolean(talentID)}
        onClose={() => dispatch(setSelectedTalentID())}
      >
        {talentID && <TalentRoute />}
      </SlidingDialog>
    </>
  );
}
